(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    const productCustomizerRows = (form) =>
      Array.from(form.querySelectorAll('.kb-cart__item[data-product-customizer-pricing-ref]'));

    const builderRowsForReference = (form, builderReference) =>
      Array.from(form.querySelectorAll('.kb-cart__item[data-kb-builder-ref]')).filter(
        (row) => row.dataset.kbBuilderRef === builderReference
      );

    const syncProductCustomizerPricing = (form) => {
      const rows = productCustomizerRows(form);

      rows.forEach((productRow) => {
        const pricingQuantity = Number(productRow.dataset.productCustomizerPricingQty || 0);
        if (!pricingQuantity) return;

        const productQuantityInput = productRow.querySelector('[data-kb-cart-quantity-input]');
        const pricingRow = rows.find((row) =>
          !row.dataset.productCustomizerPricingQty &&
          row.dataset.productCustomizerPricingRef === productRow.dataset.productCustomizerPricingRef
        );
        const pricingQuantityInput = pricingRow?.querySelector('[data-kb-cart-quantity-input]');
        if (!productQuantityInput || !pricingQuantityInput) return;

        pricingQuantityInput.value = String(
          pricingQuantity * Math.max(0, Number(productQuantityInput.value || 0))
        );
      });
    };

    const syncBuilderChargeQuantities = (form) => {
      const parentRows = Array.from(
        form.querySelectorAll('.kb-cart__item[data-kb-builder-ref]:not([data-kb-builder-charge])')
      );

      parentRows.forEach((parentRow) => {
        const builderReference = parentRow.dataset.kbBuilderRef;
        const parentQuantityInput = parentRow.querySelector('[data-kb-cart-quantity-input]');
        if (!builderReference || !parentQuantityInput) return;

        builderRowsForReference(form, builderReference).forEach((row) => {
          if (!row.hasAttribute('data-kb-builder-charge')) return;
          const chargeQuantityInput = row.querySelector('[data-kb-cart-quantity-input]');
          if (chargeQuantityInput) chargeQuantityInput.value = parentQuantityInput.value;
        });
      });
    };

    const submitForm = (form) => {
      syncProductCustomizerPricing(form);
      syncBuilderChargeQuantities(form);
      HTMLFormElement.prototype.submit.call(form);
    };

    const submitCart = (input) => {
      const form = input.closest('form');
      if (!form) return;

      window.clearTimeout(input.kbCartSubmitTimer);
      input.kbCartSubmitTimer = window.setTimeout(() => {
        submitForm(form);
      }, 260);
    };

    document.querySelectorAll('.kb-cart__form').forEach((form) => {
      form.addEventListener('submit', () => {
        syncProductCustomizerPricing(form);
        syncBuilderChargeQuantities(form);
      });

      form.querySelectorAll('.product-customizer-cart-remove').forEach((removeLink) => {
        removeLink.addEventListener('click', (event) => {
          event.preventDefault();

          const productRow = removeLink.closest('.kb-cart__item');
          if (!productRow) return;

          const productQuantityInput = productRow.querySelector('[data-kb-cart-quantity-input]');
          if (productQuantityInput) productQuantityInput.value = '0';

          submitForm(form);
        });
      });

      form.querySelectorAll('.kb-cart__item[data-kb-builder-ref] .kb-cart__remove').forEach((removeLink) => {
        removeLink.addEventListener('click', (event) => {
          event.preventDefault();

          const builderRow = removeLink.closest('.kb-cart__item[data-kb-builder-ref]');
          const builderReference = builderRow?.dataset.kbBuilderRef;
          if (!builderReference) return;

          builderRowsForReference(form, builderReference).forEach((row) => {
            const quantityInput = row.querySelector('[data-kb-cart-quantity-input]');
            if (quantityInput) quantityInput.value = '0';
          });
          submitForm(form);
        });
      });
    });

    document.querySelectorAll('[data-kb-cart-quantity]').forEach((quantity) => {
      const input = quantity.querySelector('[data-kb-cart-quantity-input]');
      const decrease = quantity.querySelector('[data-kb-cart-quantity-decrease]');
      const increase = quantity.querySelector('[data-kb-cart-quantity-increase]');
      if (!input) return;

      decrease?.addEventListener('click', () => {
        const nextValue = Math.max(Number(input.min || 0), Number(input.value || 0) - 1);
        input.value = String(nextValue);
        submitCart(input);
      });

      increase?.addEventListener('click', () => {
        input.value = String(Number(input.value || 0) + 1);
        submitCart(input);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const initializeCollection = (section) => {
      if (!section || section.dataset.collectionInitialized === 'true') return;
      section.dataset.collectionInitialized = 'true';
      section.classList.add('is-collection-enhanced');

      let lastDialogTrigger = null;
      const supportsNativeDialog = typeof window.HTMLDialogElement === 'function';

      section.querySelectorAll('[data-dialog-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const type = trigger.dataset.dialogOpen;
          const dialog = section.querySelector(
            type === 'filters' ? '[data-collection-filter-dialog]' : '[data-collection-sort-dialog]'
          );
          if (!dialog) return;
          lastDialogTrigger = trigger;
          if (supportsNativeDialog) {
            dialog.showModal();
          } else if (type === 'sort') {
            const fallback = section.querySelector('[data-collection-fallback]');
            fallback?.classList.add('is-visible');
            fallback?.querySelector('[data-collection-sort-fallback]')?.setAttribute('open', '');
          } else {
            const fallback = section.querySelector('[data-collection-fallback]');
            fallback?.classList.add('is-visible');
            fallback?.querySelector('[data-collection-filter-fallback]')?.setAttribute('open', '');
          }
        });
      });

      section.querySelectorAll('[data-collection-dialog-close]').forEach((button) => {
        button.addEventListener('click', () => {
          const dialog = button.closest('dialog');
          if (supportsNativeDialog) dialog?.close();
          else {
            dialog?.removeAttribute('open');
            lastDialogTrigger?.focus();
          }
        });
      });

      section.querySelectorAll('dialog').forEach((dialog) => {
        dialog.addEventListener('close', () => {
          lastDialogTrigger?.focus();
          lastDialogTrigger = null;
        });
        if (supportsNativeDialog) {
          dialog.addEventListener('click', (event) => {
            if (event.target === dialog) dialog.close();
          });
        }
      });

      const sortForm = section.querySelector('[data-collection-sort-form]');
      sortForm?.addEventListener('change', (event) => {
        if (!event.target.matches('input[name="sort_by"]')) return;
        sortForm.setAttribute('aria-busy', 'true');
        sortForm.querySelectorAll('input[name="sort_by"]').forEach((input) => {
          input.disabled = true;
        });
        event.target.disabled = false;
        sortForm.requestSubmit();
      });

      const loadMore = section.querySelector('[data-collection-load-more]');
      const link = loadMore?.querySelector('[data-collection-load-more-link]');
      if (!link) return;

      link.addEventListener('click', async (event) => {
        if (link.dataset.loadMoreFailed === 'true') return;
        event.preventDefault();
        if (link.getAttribute('aria-busy') === 'true') return;

        const originalText = link.textContent;
        const originalHref = link.href;
        link.setAttribute('aria-busy', 'true');
        link.textContent = link.dataset.loadingLabel;
        const status = section.querySelector('[data-collection-load-more-status]');

        try {
          const requestUrl = new URL(originalHref);
          requestUrl.searchParams.set('section_id', section.dataset.sectionId);
          const response = await fetch(requestUrl);
          if (!response.ok) throw new Error('Collection request failed');

          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incomingGrid = documentFragment.querySelector('[data-collection-grid]');
          const liveGrid = section.querySelector('[data-collection-grid]');
          if (!incomingGrid || !liveGrid) throw new Error('Collection response was incomplete');

          const incomingCards = [...incomingGrid.children];
          const existingProductIds = new Set(
            [...liveGrid.querySelectorAll('[data-product-id]')].map((card) => card.dataset.productId)
          );
          const incomingProductIds = new Set();
          incomingCards.forEach((card) => {
            const productId = card.dataset.productId;
            if (existingProductIds.has(productId) || incomingProductIds.has(productId)) {
              throw new Error('Collection response contains duplicate products');
            }
            incomingProductIds.add(productId);
          });
          incomingCards.forEach((card) => liveGrid.append(card));

          const incomingLink = documentFragment.querySelector('[data-collection-load-more-link]');
          if (incomingLink) {
            const nextUrl = new URL(incomingLink.href, window.location.origin);
            nextUrl.searchParams.delete('section_id');
            link.href = nextUrl;
            link.removeAttribute('aria-busy');
            link.textContent = originalText;
          } else {
            loadMore.remove();
          }

          if (status) {
            const loadedCountTemplate = incomingCards.length === 1
              ? status.dataset.loadedCountOne
              : status.dataset.loadedCountOther;
            status.textContent = loadedCountTemplate.replace('[count]', String(incomingCards.length));
          }
        } catch (error) {
          link.href = originalHref;
          link.removeAttribute('aria-busy');
          link.textContent = originalText;
          link.dataset.loadMoreFailed = 'true';
          if (status) status.textContent = status.dataset.loadFailure;
          window.location.assign(originalHref);
        }
      });
    };

    document.querySelectorAll('[data-collection-section]').forEach(initializeCollection);
    document.addEventListener('shopify:section:load', (event) => {
      initializeCollection(event.target.querySelector?.('[data-collection-section]') || event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kanjibrand-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const FEATURED_CLASSES = ['1', '2', '3', '4', '5'].map((column) => `kb-comparison--featured-${column}`);
    const ACTIVE_COLUMNS = ['1', '2', '3', '4', '5'];

    const canPreviewOnHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const setMobileFeaturedColumn = (section, column) => {
      if (!ACTIVE_COLUMNS.includes(column)) return;

      section.querySelectorAll('.kb-comparison__mobile').forEach((surface) => {
        surface.classList.remove(...FEATURED_CLASSES);
        surface.classList.add(`kb-comparison--featured-${column}`);
      });

      section.querySelectorAll('[data-mobile-comparison-column]').forEach((card) => {
        card.classList.toggle('is-featured', card.dataset.mobileComparisonColumn === column);
      });
    };

    const scrollMobileColumnIntoView = (section, column, behavior = 'smooth') => {
      const rail = section.querySelector('.kb-comparison__mobile');
      const card = rail?.querySelector(`[data-mobile-comparison-column="${column}"]`);
      if (!rail || !card) return;

      const targetLeft = card.offsetLeft - rail.offsetLeft - (rail.clientWidth - card.clientWidth) / 2;
      rail.scrollTo({
        left: targetLeft,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : behavior,
      });
    };

    const syncMobileFeaturedColumn = (section) => {
      const rail = section.querySelector('.kb-comparison__mobile');
      if (!rail) return;

      const cards = [...rail.querySelectorAll('[data-mobile-comparison-column]')];
      if (cards.length === 0) return;

      const railRect = rail.getBoundingClientRect();
      const railCenter = railRect.left + railRect.width / 2;
      const closestCard = cards.reduce((closest, card) => {
        const cardRect = card.getBoundingClientRect();
        const distance = Math.abs(cardRect.left + cardRect.width / 2 - railCenter);
        if (!closest || distance < closest.distance) {
          return { card, distance };
        }
        return closest;
      }, null)?.card;

      if (closestCard) {
        setMobileFeaturedColumn(section, closestCard.dataset.mobileComparisonColumn);
      }
    };

    const setFeaturedColumn = (section, column, persist = false) => {
      if (!ACTIVE_COLUMNS.includes(column)) return;

      if (persist) {
        section.dataset.activeColumn = column;
      }

      section.querySelectorAll('.kb-comparison__table-wrap').forEach((surface) => {
        surface.classList.remove(...FEATURED_CLASSES);
        surface.classList.add(`kb-comparison--featured-${column}`);
      });

      section.querySelectorAll('[data-comparison-column]').forEach((element) => {
        const isActive = element.dataset.comparisonColumn === column;

        if (element.classList.contains('kb-comparison__column-trigger')) {
          element.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }

        if (element.tagName === 'TD') {
          element.classList.toggle('is-featured', isActive);
        }
      });
    };

    const initComparison = (section) => {
      if (section.dataset.comparisonReady === 'true') return;
      section.dataset.comparisonReady = 'true';

      const table = section.querySelector('.kb-comparison__table');

      table?.addEventListener('pointerover', (event) => {
        if (!canPreviewOnHover()) return;

        const column = event.target.closest('[data-comparison-column]')?.dataset.comparisonColumn;
        if (column) setFeaturedColumn(section, column);
      });

      table?.addEventListener('pointerleave', () => {
        if (!canPreviewOnHover()) return;
        setFeaturedColumn(section, section.dataset.activeColumn || '1');
      });

      section.querySelectorAll('.kb-comparison__column-trigger[data-comparison-column]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          setFeaturedColumn(section, trigger.dataset.comparisonColumn, true);
        });

        trigger.addEventListener('focus', () => {
          setFeaturedColumn(section, trigger.dataset.comparisonColumn);
        });

        trigger.addEventListener('blur', () => {
          setFeaturedColumn(section, section.dataset.activeColumn || '1');
        });
      });

      section.querySelectorAll('.kb-comparison__mobile').forEach((rail) => {
        let scrollFrame = null;

        rail.addEventListener('scroll', () => {
          if (scrollFrame) return;

          scrollFrame = window.requestAnimationFrame(() => {
            scrollFrame = null;
            syncMobileFeaturedColumn(section);
          });
        }, { passive: true });
      });

      window.addEventListener('resize', () => syncMobileFeaturedColumn(section));
      setFeaturedColumn(section, section.dataset.activeColumn || '1', true);
      setMobileFeaturedColumn(section, section.dataset.activeColumn || '1');
      window.requestAnimationFrame(() => {
        scrollMobileColumnIntoView(section, section.dataset.activeColumn || '1', 'auto');
        syncMobileFeaturedColumn(section);
      });
    };

    const initAllComparisons = (root = document) => {
      root.querySelectorAll('[data-kb-comparison]').forEach(initComparison);
    };

    initAllComparisons();
    document.addEventListener('shopify:section:load', (event) => initAllComparisons(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kanjibrand-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const hasHorizontalOverflow = (track) => track.scrollWidth > track.clientWidth + 1;

    const getCards = (section) => [...section.querySelectorAll('[data-kb-testimonials-card]')];
    const getActiveIndex = (section) => {
      return Number(section.dataset.kbTestimonialsActive || 0);
    };

    const getVisibleStep = (track, cards) => {
      const firstCard = cards[0];
      if (!firstCard) return 1;

      const cardWidth = firstCard.getBoundingClientRect().width;
      if (cardWidth <= 0) return 1;

      return Math.max(1, Math.round(track.clientWidth / cardWidth));
    };

    const updateArrowState = (section, activeIndex) => {
      const cards = getCards(section);
      const track = section.querySelector('[data-kb-testimonials-track]');
      const previousButton = section.querySelector('[data-kb-testimonials-prev]');
      const nextButton = section.querySelector('[data-kb-testimonials-next]');

      if (!previousButton || !nextButton) return;

      const visibleStep = track ? getVisibleStep(track, cards) : 1;
      const lastStartIndex = Math.max(0, cards.length - visibleStep);
      previousButton.disabled = activeIndex <= 0;
      nextButton.disabled = activeIndex >= lastStartIndex;
    };

    const setActiveTestimonial = (section, index) => {
      const cards = getCards(section);
      const track = section.querySelector('[data-kb-testimonials-track]');
      const visibleStep = track ? getVisibleStep(track, cards) : 1;
      const lastStartIndex = Math.max(0, cards.length - visibleStep);
      const current = section.querySelector('[data-kb-testimonials-current]');
      const progress = section.querySelector('[data-kb-testimonials-progress]');
      const boundedIndex = Math.max(0, Math.min(index, Math.max(0, cards.length - 1)));

      section.dataset.kbTestimonialsActive = String(boundedIndex);

      if (current) {
        current.textContent = String(boundedIndex + 1).padStart(2, '0');
      }

      if (progress) {
        const visibleCount = cards.length > 0 ? Math.min(boundedIndex + visibleStep, cards.length) : 0;
        const progressWidth = cards.length > 0 ? (visibleCount / cards.length) * 100 : 100;
        progress.style.width = `${progressWidth}%`;
      }

      updateArrowState(section, boundedIndex);
    };

    const syncActiveTestimonial = (section) => {
      const track = section.querySelector('[data-kb-testimonials-track]');
      if (!track) return;

      const cards = getCards(section);
      if (cards.length === 0) return;

      if (!hasHorizontalOverflow(track)) {
        setActiveTestimonial(section, 0);
        return;
      }

      const visibleStep = getVisibleStep(track, cards);
      if (visibleStep > 1) {
        const firstCard = cards[0];
        const gap = Number.parseFloat(window.getComputedStyle(track).columnGap) || 0;
        const cardStep = firstCard.getBoundingClientRect().width + gap;
        const index = Math.round(track.scrollLeft / cardStep);
        setActiveTestimonial(section, Math.max(0, Math.min(index, cards.length - 1)));
        return;
      }

      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;
      const closest = cards.reduce((current, card) => {
        const cardRect = card.getBoundingClientRect();
        const distance = Math.abs(cardRect.left + cardRect.width / 2 - trackCenter);
        if (!current || distance < current.distance) {
          return { card, distance };
        }
        return current;
      }, null)?.card;

      if (!closest) return;
      setActiveTestimonial(section, Number(closest.dataset.kbTestimonialsCard));
    };

    const scrollToTestimonial = (section, index) => {
      const track = section.querySelector('[data-kb-testimonials-track]');
      const card = section.querySelector(`[data-kb-testimonials-card="${index}"]`);
      if (!track || !card || !hasHorizontalOverflow(track)) return;

      const cards = getCards(section);
      const visibleStep = getVisibleStep(track, cards);
      const centerOffset = visibleStep > 1 ? 0 : (track.clientWidth - card.clientWidth) / 2;
      const targetLeft = card.offsetLeft - track.offsetLeft - centerOffset;
      track.scrollTo({
        left: targetLeft,
        behavior: reduceMotion() ? 'auto' : 'smooth',
      });
      setActiveTestimonial(section, index);
    };

    const initTestimonials = (section) => {
      if (section.dataset.kbTestimonialsReady === 'true') return;
      section.dataset.kbTestimonialsReady = 'true';

      const track = section.querySelector('[data-kb-testimonials-track]');
      if (!track) return;

      section.querySelector('[data-kb-testimonials-prev]')?.addEventListener('click', () => {
        scrollToTestimonial(section, Math.max(0, getActiveIndex(section) - 1));
      });

      section.querySelector('[data-kb-testimonials-next]')?.addEventListener('click', () => {
        const cards = getCards(section);
        const visibleStep = getVisibleStep(track, cards);
        const lastStartIndex = Math.max(0, cards.length - visibleStep);
        scrollToTestimonial(section, Math.min(lastStartIndex, getActiveIndex(section) + 1));
      });

      let scrollFrame = null;
      track.addEventListener('scroll', () => {
        if (scrollFrame) return;

        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = null;
          syncActiveTestimonial(section);
        });
      }, { passive: true });

      window.addEventListener('resize', () => syncActiveTestimonial(section));
      window.requestAnimationFrame(() => syncActiveTestimonial(section));
    };

    const initAllTestimonials = (root = document) => {
      root.querySelectorAll('[data-kb-testimonials]').forEach(initTestimonials);
    };

    initAllTestimonials();
    document.addEventListener('shopify:section:load', (event) => initAllTestimonials(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class KbProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.dataset.loaded === 'true' || this.hidden) return;

      const url = this.dataset.kbProductRecommendationsUrl;
      if (!url) return;

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Product recommendations failed: ${response.status}`);
          }
          return response.text();
        })
        .then((text) => {
          const container = document.createElement('div');
          container.innerHTML = text;

          const incomingContent = container.querySelector('[data-kb-product-recommendations-content]');
          const incomingGrid = incomingContent?.querySelector('.kb-product-recommendations__grid');
          const currentContent = this.querySelector('[data-kb-product-recommendations-content]');

          if (!incomingContent || !incomingGrid || !currentContent) {
            this.hidden = true;
            return;
          }

          currentContent.innerHTML = incomingContent.innerHTML;
          this.dataset.loaded = 'true';
          this.hidden = false;
        })
        .catch(() => {
          this.hidden = true;
        });
    }
  }

  if (!customElements.get('kb-product-recommendations')) {
    customElements.define('kb-product-recommendations', KbProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  function findGalleryMediaIndex(mediaId, slides) {
    if (!mediaId || !slides) return -1;

    var normalizedMediaId = String(mediaId);
    return slides.findIndex(function(slide) {
      return slide.dataset.productGalleryMediaId === normalizedMediaId;
    });
  }

  if (!customElements.get('kb-product-gallery')) {
    class KbProductGallery extends HTMLElement {
      visibleThumbnails() {
        return this.galleryThumbnails.filter(function(thumbnail) {
          return !thumbnail.hidden;
        });
      }

      updateVisibleLabels() {
        var visibleThumbnails = this.visibleThumbnails();
        var viewTemplate = this.dataset.productGalleryViewTemplate || 'View media %%INDEX%% of %%COUNT%%';

        visibleThumbnails.forEach(function(thumbnail, index) {
          thumbnail.setAttribute(
            'aria-label',
            viewTemplate
              .replace('%%INDEX%%', String(index + 1))
              .replace('%%COUNT%%', String(visibleThumbnails.length))
          );
        });
      }

      updateActive(index) {
        var activeThumbnail = this.galleryThumbnails[index];
        var visibleThumbnails = this.visibleThumbnails();

        this.galleryThumbnails.forEach(function(thumbnail, thumbnailIndex) {
          thumbnail.setAttribute(
            'aria-current',
            thumbnailIndex === index && !thumbnail.hidden ? 'true' : 'false'
          );
        });

        if (this.galleryStatus && activeThumbnail && !activeThumbnail.hidden) {
          var visibleIndex = visibleThumbnails.indexOf(activeThumbnail);
          var statusTemplate = this.dataset.productGalleryStatusTemplate || 'Media %%INDEX%% of %%COUNT%%';

          this.galleryStatus.textContent = statusTemplate
            .replace('%%INDEX%%', String(visibleIndex + 1))
            .replace('%%COUNT%%', String(visibleThumbnails.length));
        }
      }

      selectMedia(mediaId, instant) {
        var index = findGalleryMediaIndex(mediaId, this.gallerySlides);
        var slide = index === -1 ? null : this.gallerySlides[index];
        if (!this.galleryTrack || !slide || slide.hidden) return false;

        this.galleryTrack.scrollTo({
          left: slide.offsetLeft,
          behavior: instant || this.galleryReducedMotion ? 'auto' : 'smooth',
        });
        this.updateActive(index);
        return true;
      }

      filterGroup(groupName, mediaId, instant) {
        var hasGroupedMedia = this.gallerySlides.some(function(slide) {
          return Boolean(slide.dataset.productGalleryGroup);
        });
        var hasRequestedGroup = this.gallerySlides.some(function(slide) {
          return slide.dataset.productGalleryGroup === groupName;
        });
        var shouldFilter = hasGroupedMedia && Boolean(groupName) && hasRequestedGroup;

        this.gallerySlides.forEach(function(slide, index) {
          var thumbnail = this.galleryThumbnails[index];
          var isVisible = !shouldFilter || slide.dataset.productGalleryGroup === groupName;

          slide.hidden = !isVisible;
          if (thumbnail) thumbnail.hidden = !isVisible;
        }, this);

        this.updateVisibleLabels();

        if (mediaId && this.selectMedia(mediaId, instant)) return;

        var firstVisibleIndex = this.gallerySlides.findIndex(function(slide) {
          return !slide.hidden;
        });
        var firstVisibleSlide = firstVisibleIndex === -1 ? null : this.gallerySlides[firstVisibleIndex];

        if (firstVisibleSlide) {
          this.selectMedia(firstVisibleSlide.dataset.productGalleryMediaId, instant);
        }
      }

      connectedCallback() {
        if (this.dataset.kbProductGalleryReady === 'true') return;

        var track = this.querySelector('[data-product-gallery-track]');
        var slides = Array.prototype.slice.call(this.querySelectorAll('[data-product-gallery-slide]'));
        var thumbnails = Array.prototype.slice.call(this.querySelectorAll('[data-product-gallery-thumbnail]'));
        var status = this.querySelector('[data-product-gallery-live-status]');

        if (!track || slides.length === 0 || thumbnails.length === 0) return;

        var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var animationFrame;
        var gallery = this;

        this.galleryTrack = track;
        this.gallerySlides = slides;
        this.galleryThumbnails = thumbnails;
        this.galleryStatus = status;
        this.galleryReducedMotion = reducedMotion;

        function closestSlideIndex() {
          var closestIndex = 0;
          var closestDistance = Infinity;

          slides.forEach(function(slide, index) {
            if (slide.hidden) return;

            var distance = Math.abs(slide.offsetLeft - track.scrollLeft);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          return closestIndex;
        }

        thumbnails.forEach(function(thumbnail, index) {
          thumbnail.addEventListener('click', function(event) {
            var slide = slides[index];
            if (!slide) return;

            event.preventDefault();
            track.scrollTo({
              left: slide.offsetLeft,
              behavior: reducedMotion ? 'auto' : 'smooth',
            });
            gallery.updateActive(index);
          });
        });

        track.addEventListener('scroll', function() {
          if (animationFrame) return;

          animationFrame = window.requestAnimationFrame(function() {
            animationFrame = undefined;
            gallery.updateActive(closestSlideIndex());
          });
        }, { passive: true });

        this.dataset.kbProductGalleryReady = 'true';
        this.filterGroup(this.dataset.productGalleryInitialGroup || '', '', true);
      }
    }

    customElements.define('kb-product-gallery', KbProductGallery);
  }

  function initKanjibrandQuantity(root) {
    var quantity = root.querySelector('[data-kb-quantity]');
    if (!quantity || quantity.dataset.kbQuantityReady === 'true') return;

    var input = quantity.querySelector('input[name="quantity"]');
    var decrease = quantity.querySelector('[data-kb-quantity-decrease]');
    var increase = quantity.querySelector('[data-kb-quantity-increase]');
    if (!input || !decrease || !increase) return;

    function normalizedValue() {
      var value = Number(input.value);
      return Number.isInteger(value) && value >= 1 ? value : 1;
    }

    function setValue(value) {
      input.value = String(Math.max(1, value));
    }

    input.addEventListener('change', function() {
      setValue(normalizedValue());
    });

    decrease.addEventListener('click', function() {
      setValue(normalizedValue() - 1);
    });

    increase.addEventListener('click', function() {
      setValue(normalizedValue() + 1);
    });

    quantity.dataset.kbQuantityReady = 'true';
  }

  function initKanjibrandPurchaseState(root) {
    var form = root.closest('form');
    var addButton = root.querySelector('.kb-product__add');
    if (!form || !addButton || form.dataset.kbPurchaseStateReady === 'true') return;

    form.addEventListener('submit', function() {
      if (addButton.disabled) return;

      addButton.textContent = addButton.dataset.addingLabel || addButton.textContent;
      addButton.setAttribute('aria-busy', 'true');
    });

    form.dataset.kbPurchaseStateReady = 'true';
  }

  function isOptionValueAvailable(variants, currentOptions, optionIndex, candidateValue) {
    return variants.some(function(variant) {
      if (!variant.options || variant.available === false) return false;

      for (var index = 0; index <= optionIndex; index += 1) {
        var expectedValue = index === optionIndex ? candidateValue : currentOptions[index];
        if (variant.options[index] !== expectedValue) return false;
      }

      return true;
    });
  }

  function initKanjibrandProductOptions(root) {
    if (!root || root.dataset.kbProductOptionsReady === 'true') return;

    initKanjibrandQuantity(root);
    initKanjibrandPurchaseState(root);

    var variantData = root.querySelector('[data-kb-variant-data]');
    var variantId = root.querySelector('[data-kb-variant-id]');
    var variantLookup = root.querySelector('[data-kb-variant-lookup]');
    var radios = Array.prototype.slice.call(root.querySelectorAll('[data-kb-option-radio]'));
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-kb-option-group]'));

    if (!variantData || !variantId || !variantLookup || radios.length === 0 || groups.length === 0) return;

    var variants = [];

    try {
      variants = JSON.parse(variantData.textContent || '[]');
    } catch (error) {
      return;
    }

    variantId.disabled = false;

    var section = root.closest('[data-kb-product-section]');
    var price = section ? section.querySelector('[data-kb-product-price]') : null;
    var comparePrice = section ? section.querySelector('[data-kb-product-compare-price]') : null;
    var saleLabel = section ? section.querySelector('[data-kb-product-sale-label]') : null;
    var addButton = root.querySelector('.kb-product__add');
    var status = root.querySelector('[data-kb-variant-status]');
    var selectedTemplate = root.dataset.selectedVariantTemplate || 'Selected: %%VARIANT%%';
    var unavailableText = root.dataset.unavailableVariant || 'Selected option is unavailable';

    function restorePurchaseState(available) {
      if (!addButton) return;

      addButton.disabled = !available;
      addButton.textContent = available
        ? (addButton.dataset.addLabel || addButton.textContent)
        : (addButton.dataset.soldOutLabel || addButton.textContent);
      addButton.removeAttribute('aria-busy');
    }

    function selectedOptions() {
      return groups.map(function(group) {
        var checked = root.querySelector(
          '[data-kb-option-radio][data-option-position="' + group.dataset.optionPosition + '"]:checked'
        );

        return checked ? checked.value : '';
      });
    }

    function selectedOptionLabels() {
      return groups.map(function(group) {
        var checked = root.querySelector(
          '[data-kb-option-radio][data-option-position="' + group.dataset.optionPosition + '"]:checked'
        );

        return checked ? (checked.dataset.kbDisplayValue || checked.value) : '';
      });
    }

    function findVariant(options) {
      return variants.find(function(variant) {
        if (!variant.options) return false;

        return variant.options.every(function(value, index) {
          return value === options[index];
        });
      });
    }

    function setOptionAvailability(currentOptions) {
      radios.forEach(function(radio) {
        var optionIndex = Number(radio.dataset.optionPosition) - 1;
        radio.disabled = !isOptionValueAvailable(variants, currentOptions, optionIndex, radio.value);
      });
    }

    function updateVariantState() {
      var options = selectedOptions();
      var variant = findVariant(options);

      setOptionAvailability(options);

      if (!variant) {
        restorePurchaseState(false);
        if (status) {
          status.textContent = unavailableText;
          status.classList.remove('kb-visually-hidden');
        }
        return;
      }

      variantId.value = String(variant.id);
      var selectedOption = variantLookup.querySelector('option[value="' + variant.id + '"]');

      if (price) {
        if (selectedOption && selectedOption.dataset.price) {
          price.textContent = selectedOption.dataset.price;
        }

        if (comparePrice) {
          var hasComparePrice = variant.compare_at_price > variant.price;
          if (hasComparePrice && selectedOption && selectedOption.dataset.comparePrice) {
            comparePrice.textContent = selectedOption.dataset.comparePrice;
          }
          comparePrice.hidden = !hasComparePrice;
          if (saleLabel) saleLabel.hidden = !hasComparePrice;
        }
      }

      var featuredMediaId = selectedOption ? selectedOption.dataset.featuredMediaId : '';
      var gallery = section ? section.querySelector('kb-product-gallery') : null;
      if (gallery && typeof gallery.filterGroup === 'function') {
        gallery.filterGroup(options[0] || '', featuredMediaId);
      } else if (featuredMediaId && gallery && typeof gallery.selectMedia === 'function') {
        gallery.selectMedia(featuredMediaId);
      }

      restorePurchaseState(variant.available !== false);

      if (status) {
        if (variant.available === false) {
          status.textContent = unavailableText;
          status.classList.remove('kb-visually-hidden');
        } else {
          status.textContent = selectedTemplate.replace('%%VARIANT%%', selectedOptionLabels().join(' / '));
          status.classList.add('kb-visually-hidden');
        }
      }
    }

    radios.forEach(function(radio) {
      radio.addEventListener('change', updateVariantState);
    });

    root.dataset.kbProductOptionsReady = 'true';
    updateVariantState();
  }

  function initKanjibrandProductForms(container) {
    var scope = container || document;
    var roots = scope.querySelectorAll('[data-kb-product-form]');

    roots.forEach(initKanjibrandProductOptions);
  }

  function initKanjibrandInlineGuides(section) {
    if (!section || section.dataset.kbInlineGuidesReady === 'true') return;

    var guides = Array.prototype.slice.call(section.querySelectorAll('[data-kb-inline-guide]'));
    var configUrl = section.dataset.kbBuilderConfigUrl;
    var productId = section.dataset.kbBuilderProductId;
    if (!guides.length || !configUrl || !productId) return;

    function setUnavailable(guide) {
      var status = guide.querySelector('[data-kb-inline-guide-status]');
      if (status) status.textContent = guide.dataset.unavailableLabel || '';
    }

    function createChip(text, color) {
      var item = document.createElement('li');
      item.className = 'kb-product-guide__chip';

      if (color) {
        var swatch = document.createElement('span');
        swatch.className = 'kb-product-guide__swatch';
        swatch.setAttribute('aria-hidden', 'true');
        swatch.style.setProperty('--kb-thread-color', color);
        item.appendChild(swatch);
      }

      item.appendChild(document.createTextNode(text));
      return item;
    }

    function createChipList(values) {
      var list = document.createElement('ul');
      list.className = 'kb-product-guide__chips';
      values.forEach(function(value) {
        list.appendChild(createChip(value.label, value.color));
      });
      return list;
    }

    function matchingSizeMeasurements(sizeChart, product, availableSizes) {
      if (!sizeChart || !Array.isArray(sizeChart.models) || !product || !Array.isArray(availableSizes)) return [];

      function normalized(value) {
        return String(value || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '');
      }

      var productKeys = [product.title, product.handle].map(normalized).filter(Boolean);
      var model = sizeChart.models.find(function(candidate) {
        var modelKey = normalized(candidate && candidate.model);
        return modelKey && productKeys.includes(modelKey);
      });
      if (!model || !Array.isArray(model.sizes)) return [];

      var measurements = availableSizes.map(function(size) {
        var sizeKey = normalized(size);
        var match = model.sizes.find(function(candidate) {
          return normalized(candidate && candidate.label) === sizeKey;
        });
        if (!match || !String(match.measurement || '').trim()) return null;
        return { label: String(size), measurement: String(match.measurement).trim() };
      }).filter(Boolean);

      return measurements.length === availableSizes.length ? measurements : [];
    }

    function loadSizeChart(guide) {
      var guideLink = guide && guide.dataset.guideLink;
      if (!guideLink) return Promise.resolve(null);

      return fetch(guideLink, { credentials: 'same-origin' })
        .then(function(response) {
          if (!response.ok) throw new Error('Size chart unavailable');
          return response.text();
        })
        .then(function(html) {
          var documentFragment = new DOMParser().parseFromString(html, 'text/html');
          var source = documentFragment.querySelector('[data-kb-size-chart]');
          if (!source) throw new Error('Size chart data unavailable');
          return JSON.parse(source.textContent || '{}');
        });
    }

    function renderSizeGuide(guide, config, sizeChart) {
      var profile = config.profile || {};
      var standardSizeOptionNames = profile.config && profile.config.variantOptions && profile.config.variantOptions.size || [];
      var readyMadeSizeOptionNames = profile.config && profile.config.nativeVariantOptions && profile.config.nativeVariantOptions.sizeOptionNames || [];
      var configuredNames = standardSizeOptionNames.concat(readyMadeSizeOptionNames).map(function(name) {
        return String(name).trim().toLowerCase();
      });
      var productOptions = config.product && Array.isArray(config.product.options) ? config.product.options : [];
      var sizeOption = productOptions.find(function(option) {
        return option && configuredNames.includes(String(option.name || '').trim().toLowerCase());
      });
      var sizes = sizeOption && Array.isArray(sizeOption.values) ? sizeOption.values.filter(Boolean) : [];
      var measurements = matchingSizeMeasurements(sizeChart, config.product, sizes);
      var content = guide.querySelector('[data-kb-inline-guide-content]');

      if (!content || !measurements.length) {
        setUnavailable(guide);
        return;
      }

      content.replaceChildren();
      var heading = document.createElement('p');
      heading.className = 'kb-product-guide__heading';
      heading.textContent = guide.dataset.availableSizesLabel || '';
      content.appendChild(heading);
      var list = document.createElement('ul');
      list.className = 'kb-product-guide__chips';
      measurements.forEach(function(item) {
        var chip = createChip(item.label);
        chip.classList.add('kb-product-guide__chip--measurement');
        var measurement = document.createElement('span');
        measurement.textContent = item.measurement;
        chip.appendChild(measurement);
        list.appendChild(chip);
      });
      content.appendChild(list);

      var note = document.createElement('p');
      note.className = 'kb-product-guide__note';
      note.textContent = guide.dataset.sizeNote || '';
      content.appendChild(note);
    }

    function renderEmbroideryGuide(guide, payload) {
      var profile = payload.profile || {};
      var config = profile.config || {};
      var enabledSides = Array.isArray(config.enabledSides) ? config.enabledSides : [];
      var allowedModes = config.allowedModes || {};
      var orientations = Array.isArray(config.orientations) ? config.orientations : [];
      var threadColors = Array.isArray(config.threadColors) ? config.threadColors : [];
      var maxTextLength = config.maxTextLength || {};
      var verticalMaxCharacters = config.verticalMaxCharacters || {};
      var content = guide.querySelector('[data-kb-inline-guide-content]');
      if (!content || !enabledSides.length) {
        setUnavailable(guide);
        return;
      }

      var labels = {
        bar: guide.dataset.barSideLabel,
        logo: guide.dataset.logoSideLabel,
        text: guide.dataset.textLabel,
        horizontal: guide.dataset.horizontalLabel,
        vertical: guide.dataset.verticalLabel
      };
      var modes = [];
      enabledSides.forEach(function(side) {
        var sideModes = Array.isArray(allowedModes[side]) ? allowedModes[side] : [];
        sideModes.forEach(function(mode) {
          if (mode !== 'none' && !modes.includes(mode)) modes.push(mode);
        });
      });

      function addFact(list, label, values) {
        if (!values.length) return;
        var row = document.createElement('div');
        row.className = 'kb-product-guide__fact';
        var term = document.createElement('dt');
        term.textContent = label;
        var description = document.createElement('dd');
        description.appendChild(createChipList(values));
        row.appendChild(term);
        row.appendChild(description);
        list.appendChild(row);
      }

      content.replaceChildren();
      var heading = document.createElement('p');
      heading.className = 'kb-product-guide__heading';
      heading.textContent = guide.dataset.availableCustomizationLabel || '';
      content.appendChild(heading);

      var facts = document.createElement('dl');
      facts.className = 'kb-product-guide__facts';
      addFact(facts, guide.dataset.availableSidesLabel || '', enabledSides.map(function(side) {
        return { label: labels[side] || side };
      }));
      addFact(facts, guide.dataset.customizationModesLabel || '', modes.map(function(mode) {
        return { label: mode === 'logo' ? guide.dataset.logoLabel : labels[mode] || mode };
      }));
      addFact(facts, guide.dataset.orientationsLabel || '', orientations.map(function(orientation) {
        return { label: labels[orientation] || orientation };
      }));
      addFact(facts, guide.dataset.threadColorsLabel || '', threadColors.map(function(color) {
        return { label: String(color.name || ''), color: color.hex };
      }).filter(function(color) { return color.label; }));
      content.appendChild(facts);

      if (modes.includes('text')) {
        var horizontalLimit = Math.max.apply(null, enabledSides.map(function(side) {
          return Number(maxTextLength[side]) || 0;
        }));
        var verticalLimit = Math.max.apply(null, enabledSides.map(function(side) {
          return Number(verticalMaxCharacters[side]) || 0;
        }));
        if (horizontalLimit || verticalLimit) {
          var note = document.createElement('p');
          note.className = 'kb-product-guide__note';
          note.textContent = (guide.dataset.textLimitsTemplate || '')
            .replace('__HORIZONTAL__', String(horizontalLimit))
            .replace('__VERTICAL__', String(verticalLimit));
          content.appendChild(note);
        }
      }
    }

    section.dataset.kbInlineGuidesReady = 'true';
    var sizeGuide = guides.find(function(guide) { return guide.dataset.kbInlineGuide === 'size_guide'; });
    var sizeChartRequest = sizeGuide
      ? loadSizeChart(sizeGuide).catch(function() { return null; })
      : Promise.resolve(null);
    var configRequest = fetch(configUrl + '?product_id=' + encodeURIComponent(productId), { credentials: 'same-origin' })
      .then(function(response) {
        if (!response.ok) throw new Error('Builder configuration unavailable');
        return response.json();
      });

    Promise.all([configRequest, sizeChartRequest])
      .then(function(results) {
        var config = results[0];
        var sizeChart = results[1];
        guides.forEach(function(guide) {
          if (guide.dataset.kbInlineGuide === 'size_guide') renderSizeGuide(guide, config, sizeChart);
          if (guide.dataset.kbInlineGuide === 'embroidery_guide') renderEmbroideryGuide(guide, config);
        });
      })
      .catch(function() {
        guides.forEach(setUnavailable);
      });
  }

  function initKanjibrandProductSections(container) {
    var scope = container || document;
    scope.querySelectorAll('[data-kb-product-section]').forEach(initKanjibrandInlineGuides);
  }

  function removeLegacyProductCustomizerProperties(form) {
    [
      'properties[Adding Embroidery]',
      'properties[Professor Stripes Embroidery]'
    ].forEach(function(propertyName) {
      form.querySelectorAll('[name="' + propertyName + '"]').forEach(function(input) {
        input.remove();
      });
    });
  }

  function addProductCustomizerPricing(event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[action*="/cart/add"]')) return;

    // These are retired Product Options fields. The belt builder uses separate
    // order data, so never send the old defaults to Shopify orders.
    removeLegacyProductCustomizerProperties(form);

    var optionsContainer = form.querySelector('.product-customizer-options[data-product-customizer-option-pricing="true"]');
    if (!optionsContainer) return;

    var customizationTotal = form.querySelector('.product-customizer-customizations-total span');
    var customizationAmount = customizationTotal
      ? Number(customizationTotal.textContent.replace(/[^0-9.-]/g, ''))
      : 0;

    if (!customizationAmount) {
      event.preventDefault();
      event.stopImmediatePropagation();
      form.querySelectorAll('input[name^="properties[_pc_pricing"]').forEach(function(input) {
        input.remove();
      });
      HTMLFormElement.prototype.submit.call(form);
      return;
    }

    ['_pc_pricing_ref', '_pc_pricing_qty'].forEach(function(propertyName) {
      var inputName = 'properties[' + propertyName + ']';
      if (form.querySelector('input[name="' + inputName + '"]')) return;

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = inputName;
      optionsContainer.appendChild(input);
    });

    var productCustomizer = window.shopstorm &&
      window.shopstorm.apps &&
      window.shopstorm.apps.productCustomizer;

    if (!productCustomizer || typeof productCustomizer.addOptionPricingItemToCart !== 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();

    window.pc_function_active = false;
    productCustomizer.disableStandardICSubmitEvent = true;
    var canSubmit = productCustomizer.addOptionPricingItemToCart(optionsContainer.dataset.productId);

    if (canSubmit !== false) {
      ['_pc_pricing_ref', '_pc_pricing_qty'].forEach(function(propertyName) {
        var inputName = 'properties[' + propertyName + ']';
        var sourceInput = optionsContainer.querySelector('input[name="' + inputName + '"]');
        if (!sourceInput || !sourceInput.value) return;

        var formInput = document.createElement('input');
        formInput.type = 'hidden';
        formInput.name = inputName;
        formInput.value = sourceInput.value;
        form.appendChild(formInput);
      });

      HTMLFormElement.prototype.submit.call(form);
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    initKanjibrandProductForms(document);
    initKanjibrandProductSections(document);
  });

  document.addEventListener('submit', addProductCustomizerPricing, true);

  document.addEventListener('shopify:section:load', function(event) {
    initKanjibrandProductForms(event.target);
    initKanjibrandProductSections(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
